module.exports = __webpack_public_path__ + "img/Icon-credit-auth.1b4cc4ed.svg";